import { EDealType } from '../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { EEntityType } from '../types/filters';

/**
 * Возвращает ссылку для скачивания выдачи в excel формате
 *
 * @param dealType тип сделки
 * @param favoriteEntityType тип предложения
 */
export function getExcelUrl(dealType: EDealType, favoriteEntityType: EEntityType): string {
  const getOfferTypeQuery = (favoriteEntityType: EEntityType) => {
    if (favoriteEntityType === EEntityType.Commercial) {
      return 'offices';
    }

    if (favoriteEntityType === EEntityType.Newbuilding) {
      return 'newobject';
    }

    if (favoriteEntityType === EEntityType.Residential) {
      return 'flat';
    }

    return favoriteEntityType;
  };

  const path = '/export/xls/offers/favorites/';
  const dealTypeQuery = `deal_type=${dealType}`;
  const favoriteEntityTypeQuery = `offer_type=${getOfferTypeQuery(favoriteEntityType)}`;

  return `${path}?${dealTypeQuery}&${favoriteEntityTypeQuery}`;
}

/**
 * Возвращает ссылку для скачивания docx карточки
 * @param dealType тип сделки
 * @param favoriteEntityType тип предложения
 * @param entityId айди предложения
 */
export function getDocxUrl(
  dealType: EDealType | null,
  favoriteEntityType: EEntityType | null,
  entityId: number,
): string | null {
  if (favoriteEntityType === EEntityType.Newbuilding || !dealType || !favoriteEntityType) {
    return null;
  }

  return `/export/docx/${dealType}/${
    favoriteEntityType === EEntityType.Residential ? 'flat' : favoriteEntityType
  }/${entityId}`;
}

/**
 * Возвращает ссылку для скачивания pdf карточки
 * @param dealType тип сделки
 * @param favoriteEntityType тип предложения
 * @param entityId айди предложения
 */
export function getPdfUrl(
  dealType: EDealType | null,
  favoriteEntityType: EEntityType | null,
  entityId: number,
): string | null {
  if (favoriteEntityType === EEntityType.Newbuilding || !dealType || !favoriteEntityType) {
    return null;
  }

  return `/export/pdf/${dealType}/${
    favoriteEntityType === EEntityType.Residential ? 'flat' : favoriteEntityType
  }/${entityId}`;
}
